import { assetUrl } from "@/lib/api";

const TONES = ["bg-cyan-100 text-cyan-800", "bg-orange-100 text-orange-800", "bg-violet-100 text-violet-800", "bg-lime-100 text-lime-800",
  "bg-pink-100 text-pink-800", "bg-amber-100 text-amber-800", "bg-sky-100 text-sky-800", "bg-emerald-100 text-emerald-800"];
const tone = (s = "") => TONES[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % TONES.length];

export const Avatar = ({ user, className = "w-10 h-10", ring = "border-2 border-white shadow-sm", testid }) => {
  const initials = `${user?.first_name?.[0] || ""}${user?.last_name?.[0] || ""}`.toUpperCase();
  const src = assetUrl(user?.avatar_url);
  return (
    <div data-testid={testid} className={`${className} ${ring} rounded-full overflow-hidden ${tone(user?.id || initials)} shrink-0 flex items-center justify-center font-display font-bold select-none`}>
      {src ? <img src={src} alt={user?.short_name} className="w-full h-full object-cover" draggable={false} /> : <span className="text-[0.7em] leading-none" style={{ fontSize: "inherit" }}>{initials || "?"}</span>}
    </div>
  );
};

export const TeamDot = ({ team, className = "w-2.5 h-2.5" }) =>
  team ? <span className={`${className} inline-block rounded-full ${team === "white" ? "bg-white border border-slate-400" : "bg-zinc-950"}`} /> : null;
